import { render, staticRenderFns } from "./newscenter.vue?vue&type=template&id=3a3e7c4c&scoped=true&"
import script from "./newscenter.vue?vue&type=script&lang=js&"
export * from "./newscenter.vue?vue&type=script&lang=js&"
import style0 from "./newscenter.vue?vue&type=style&index=0&id=3a3e7c4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3e7c4c",
  null
  
)

export default component.exports